/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m10.9855 9.6328 1.1836 1.1836-1.3527 1.3527-1.1836-1.1836c-1.1206-1.1206-2.9374-1.1206-4.058 0L.8404 15.7199c-1.1205 1.1205-1.1205 2.9374 0 4.058l3.3817 3.3817c1.1206 1.1205 2.9375 1.1205 4.058 0l4.7344-4.7344c1.1206-1.1206 1.1206-2.9374 0-4.058l-1.1836-1.1836 1.3527-1.3527 1.1836 1.1836c1.1206 1.1206 2.9374 1.1206 4.058 0l4.7344-4.7343c1.1205-1.1206 1.1205-2.9375 0-4.058L19.7779.8403c-1.1206-1.1205-2.9375-1.1205-4.058 0l-4.7344 4.7344c-1.1206 1.1206-1.1206 2.9374 0 4.058Zm11.1596-4.3962L18.7634 1.855c-.5603-.5602-1.4687-.5602-2.029 0L12 6.5893c-.5603.5603-.5603 1.4687 0 2.029l1.1836 1.1836 3.029-3.029a.7174.7174 0 1 1 1.0145 1.0145l-3.029 3.029L15.3817 12c.5603.5603 1.4687.5603 2.029 0l4.7344-4.7344c.5602-.5602.5602-1.4687 0-2.029Zm-12.3432 7.947-3.029 3.029a.7174.7174 0 1 0 1.0145 1.0145l3.029-3.029L12 15.3817c.5603.5603.5603 1.4687 0 2.029l-4.7344 4.7344c-.5602.5602-1.4687.5602-2.029 0L1.855 18.7634c-.5602-.5603-.5602-1.4687 0-2.029L6.5893 12c.5603-.5603 1.4687-.5603 2.029 0l1.1836 1.1836Z"
    clipRule="evenodd"
  />,
  'MenuURLs'
);
